<template>
    <v-row class="ma-0 pa-0" justify="start">
        <v-col cols="12" :style="{height: chart_height + 'px'}" class="py-1">
            <v-chart :id="chart_id" class="chart" :key="chart_key" :option="graph_options" autoresize></v-chart>
        </v-col>
    </v-row>
</template>

<script>
import VChart, { THEME_KEY } from 'vue-echarts';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers'; 'echarts/charts';
import cpalette from "@/configs/ChartColors/get_color_palette";
import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
} from 'echarts/components';

use([
    CanvasRenderer,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
]);
export default {
    name: 'SweetSpotPieChart',
    props: ["chart_title", "chart_data", "chart_id", "chart_options", "color_palette", "chart_key"],
    provide: {
        [THEME_KEY]: 'light',
    },
    components: {
        VChart
    },
    data: () => ({
        chart_height: Math.max(screen.width * 0.20, 320),
    }),
    methods: {
        open_further_details: function(){
            if(this.link){
                this.$router.replace(this.link);
            }
        }
    },
    computed: {
        graph_options: function() {
            const option = {
                title: {
                    text: this.chart_title,
                    fontFamily: "Poppins"
                },
                color: cpalette.get_color_palette(this.color_palette),
                tooltip: {
                    trigger: 'item',
                    textStyle: {
                        fontFamily: "Poppins",
                    },
                    formatter: function (param) {
                        return param.data['tooltip'];
                    }
                },
                legend: {
                    show: true,
                    type: 'scroll',
                    orient: 'horizontal',
                    left: 'center',
                    bottom: 0,
                    pageIconColor: '#000000',
                    pageIconInactiveColor: '#BDBDBD',
                    pageTextStyle: {
                        color: '#000000',
                        fontFamily: "Poppins",
                    },
                },
                grid: {
                    left: "5%",
                    right: "5%",
                    top: "20%",
                    bottom: "18%",
                    containLabel: true,
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: [ '42%','76%'],
                        center: ['50%', '42%'],
                        // color: COLOR_PALETTE,
                        data: this.chart_data,
                        label: {
                            show: true,
                            fontFamily: "Poppins",
                            fontSize: 12,
                            color: '#ffffff',
                            formatter: '{d}%',
                            position: 'inside',
                        },
                        labelLine: {
                            show: false
                        },
                    },
                ],
            }
            return option;
        }
    },
}
</script>

<style scoped>
    .chart_title{
        font-family: "Poppins" !important;
        font-weight: 600;
        font-size: 12pt !important;
        line-height: 40px;

        display: block;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .chart_wrapper{
        height: 28vh;
        font-family: "Gothic" !important;
    }
    .chart_style {
        height: 100%;
        width: 100%;
    }
</style>
